import SectionHeading from "../../../../../../../shared/components/ui/SectionHeading/SectionHeading";
import { HeartDrawIcon } from "../AboutDecorations/AboutDecorations.jsx";
import AboutTexts from "../AboutTexts/AboutTexts.jsx";
import AboutCTA from "../AboutCTA/AboutCTA.jsx";

import "./AboutContent.css";

export default function AboutContent({ about }) {
  return (
    <div className="about-preview__content">
      <div className="reveal-on-scroll reveal-on-scroll--up reveal-delay-1">
        <SectionHeading
          eyebrow={about.eyebrow}
          title={
            <>
              {about.titleBefore} <em>{about.titleEmphasis}</em>
              <br />
              {about.titleAfter}
            </>
          }
          align="left"
          className="about-preview__heading"
        />
      </div>

      <div className="about-preview__title-area about-preview__title-area--decor-only reveal-on-scroll reveal-on-scroll--scale reveal-delay-2">
        <HeartDrawIcon />
      </div>

      <span className="about-preview__gold-line reveal-on-scroll reveal-on-scroll--right reveal-delay-2" />

      <AboutTexts paragraphs={about.paragraphs} />

      <AboutCTA scriptText={about.scriptText} />
    </div>
  );
}